import type { Holiday, OpeningHours } from 'lib-shared-types-api';

import { getExceptionsFromHolidays } from 'utils/holidays';

export function getDeletedHolidays({
  holidays,
  exceptions,
  agentName,
}: {
  holidays: readonly Holiday[];
  exceptions: OpeningHours[];
  agentName: string;
}): OpeningHours[] {
  const exceptionHolidayIds = exceptions.reduce<string[]>(
    (acc, { opening_hour_type, recurring }) => {
      const isHoliday = opening_hour_type === 'holiday' && recurring?.holiday;

      return isHoliday ? [...acc, recurring.holiday] : acc;
    },
    [],
  );

  const deletedHolidays = holidays.filter(
    ({ id: holidayId }) => !exceptionHolidayIds.includes(holidayId),
  );

  return getExceptionsFromHolidays({
    agentName,
    holidays: deletedHolidays,
    isClosed: true,
  });
}
